import React from 'react';
import { Flash } from '@amzn/awsui-components-react/polaris';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../res/actions';

class Notification extends React.Component{
  constructor(props){
    super(props);
    this.clearNotification = this.clearNotification.bind(this);
    this.onDismissEvent = this.onDismissEvent.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  clearNotification(){
    this.props.clearSingleNotification(this.props.notification.id);
  }

  componentDidMount(){
    if(this.props.notification.autoHide){
      setTimeout(()=>{
        this.clearNotification();
      }, 10000);
    }
  }

  onDismissEvent(event){
    this.clearNotification();
  }

  onButtonClick(event){
  }
 
  render(){
    return(
      <Flash
        type={this.props.notification.type}
        dismissible={this.props.notification.dismissible}
        visible={this.props.notification.visible}
        header={this.props.notification.header}
        content={this.props.notification.content}
        loading={this.props.notification.loading}
        buttonText={this.props.notification.buttonText}
        buttonLinkTo={this.props.notification.buttonLinkTo}
        onDismiss={this.onDismissEvent}
        onButtonClick={this.onButtonClick}
      ></Flash>
    );
  }
}

export default connect(null, (dispatch) => bindActionCreators(actionCreators,dispatch))(Notification);



// WEBPACK FOOTER //
// ./src/app/components/Notification.jsx